import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    display: "flex",
    height: "80px",
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "stretch",
    gap: theme.spacing.space16,
    padding: "16px 12px",
    background: theme.colors.Background3,
    borderRadius: theme.radius.small,
  },
  image: {
    height: "48px",
  },
  textContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
    gap: theme.spacing.space8,
  },
  achievementText: {
    lineHeight: "22.4px !important",
    fontStyle: "normal",
  },
  progress: {
    display: "flex !important",
    height: "10px !important",
    padding: "1px !important",
    alignItems: "flex-start !important",
    gap: "10px",
    alignSelf: "stretch",
    borderRadius: "24px !important",
    background: `${theme.colors.Background5} !important`,
  },
}));
